import EVENTS from './mini-cart-events.js';

class CloseCart extends HTMLElement {
  connectedCallback() {
    const btn = this.querySelector('.js-close-header-cart');
    if (!btn) return;

    btn.addEventListener('click', () => {
      document.dispatchEvent(
        new CustomEvent(EVENTS.cartClose, { bubbles: true })
      );
    });
  }
}

customElements.define('close-cart', CloseCart);
export default CloseCart;
